import api from "@/shared/services/apiClient";
import type { ReturnHomeFormData, ReturnHomeFilters } from "@/features/return-home/types/returnHome";

export const returnHomeService = {
  search: async (filters: ReturnHomeFilters = {}) => {
    const cleanFilters: Record<string, string> = {};
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "" && value !== "All") {
        cleanFilters[key] = value;
      }
    });
    const response = await api.get("/return-home/search", { params: cleanFilters });
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get(`/return-home/${id}`);
    return response.data;
  },

  create: async (data: ReturnHomeFormData) => {
    const response = await api.post("/return-home/create", data);
    return response.data;
  },

  update: async (id: string, data: Partial<ReturnHomeFormData>) => {
    const response = await api.put(`/return-home/update/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/return-home/delete/${id}`);
    return response.data;
  },

  approve: async (id: string, data: { status: string; approver_remarks?: string }) => {
    const response = await api.patch(`/return-home/approve/${id}`, data);
    return response.data;
  },

  cancelApproved: async (id: string, cancellationReason: string) => {
    const response = await api.patch(`/return-home/cancel/${id}`, {
      cancellation_reason: cancellationReason,
    });
    return response.data;
  },

  patchStatus: async (id: string, status: "Draft" | "Pending") => {
    const response = await api.patch(`/return-home/status/${id}`, { status });
    return response.data;
  },
};
